/**
 * Converts date from DD/MM/YYYY format to YYYY-MM-DD format
 * @param date - Date string in DD/MM/YYYY format
 * @returns Date string in YYYY-MM-DD format
 */
export const convertDDMMYYYYToISO = (date: string): string => {
    if (!date) return ''
    
    const dateParts = date.split('/')
    if (dateParts.length !== 3) return date // Return original if not in expected format
    
    const [day, month, year] = dateParts
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
}

/**
 * Converts date from YYYY-MM-DD format to DD/MM/YYYY format
 * @param date - Date string in YYYY-MM-DD format
 * @returns Date string in DD/MM/YYYY format
 */
export const convertISOToDDMMYYYY = (date: string): string => {
    if (!date) return ''
    
    const dateParts = date.split('-')
    if (dateParts.length !== 3) return date // Return original if not in expected format
    
    const [year, month, day] = dateParts
    return `${day}/${month}/${year}`
}